/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    /*!
     * JavaScript Cookie v2.0.4
     * https://github.com/js-cookie/js-cookie
     *
     * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
     * Released under the MIT license
     */
    (function (a) {
        if (typeof define === "function" && define.amd) {
            define(a);
        } else {
            if (typeof exports === "object") {
                module.exports = a();
            } else {
                var c = window.Cookies;
                var b = window.Cookies = a();
                b.noConflict = function () {
                    window.Cookies = c;
                    return b;
                };
            }
        }
    }(function () {
        function b() {
            var f = 0;
            var c = {};
            for (; f < arguments.length; f++) {
                var d = arguments[f];
                for (var e in d) {
                    c[e] = d[e];
                }
            }
            return c;
        }

        function a(d) {
            function c(o, n, k) {
                var r;
                if (arguments.length > 1) {
                    k = b({path: "/"}, c.defaults, k);
                    if (typeof k.expires === "number") {
                        var h = new Date();
                        h.setMilliseconds(h.getMilliseconds() + k.expires * 86400000);
                        k.expires = h;
                    }
                    try {
                        r = JSON.stringify(n);
                        if (/^[\{\[]/.test(r)) {
                            n = r;
                        }
                    } catch (m) {
                    }
                    n = encodeURIComponent(String(n));
                    n = n.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
                    o = encodeURIComponent(String(o));
                    o = o.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
                    o = o.replace(/[\(\)]/g, escape);
                    return (document.cookie = [o, "=", n, k.expires && "; expires=" + k.expires.toUTCString(), k.path && "; path=" + k.path, k.domain && "; domain=" + k.domain, k.secure ? "; secure" : ""].join(""));
                }
                if (!o) {
                    r = {};
                }
                var q = document.cookie ? document.cookie.split("; ") : [];
                var p = /(%[0-9A-Z]{2})+/g;
                var l = 0;
                for (; l < q.length; l++) {
                    var j = q[l].split("=");
                    var f = j[0].replace(p, decodeURIComponent);
                    var g = j.slice(1).join("=");
                    if (g.charAt(0) === '"') {
                        g = g.slice(1, -1);
                    }
                    try {
                        g = d && d(g, f) || g.replace(p, decodeURIComponent);
                        if (this.json) {
                            try {
                                g = JSON.parse(g);
                            } catch (m) {
                            }
                        }
                        if (o === f) {
                            r = g;
                            break;
                        }
                        if (!o) {
                            r[f] = g;
                        }
                    } catch (m) {
                    }
                }
                return r;
            }

            c.get = c.set = c;
            c.getJSON = function () {
                return c.apply({json: true}, [].slice.call(arguments));
            };
            c.defaults = {};
            c.remove = function (f, e) {
                c(f, "", b(e, {expires: -1}));
            };
            c.withConverter = a;
            return c;
        }

        return a();
    }));

    var data;
    var obj;
    var is_root = window.location.pathname === "/";

    var processData = function (x) {
        var y = {};
        for (var i = 0; i < x.length - 1; i++) {
            var split = x[i].split('=');
            y[split[0].trim()] = split[1].trim();
        }
        return y;
    };

    var objData = function (x) {
        return obj[x];
    };

    var createRedirect = function () {
        var check = typeof objData('loc');
        if (check !== 'undefined') {
            var location = objData('loc').toLowerCase();
            var active_langs = {
                at: 'at',
                ca: 'ca',
                cs: 'cs',
                en: 'uk',
                de: 'de',
                fi: 'fi',
                ie: 'ga',
                no: 'no',
                pl: 'pl',
                se: 'sv',
                ch: 'ch',
                es: 'es'
            };

            if (Object.keys(active_langs).indexOf(location) >= 0 && window.location.href.indexOf('/' + active_langs[location] + '/') < 0) {
                window.location.replace(window.location.protocol + '//' + window.location.hostname + "/" + active_langs[location] + "/");
            }
            else {
                console.log("Redirect not working for " + location);
            }
        }
    };

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {

                // JavaScript to be fired on all pages
                if (is_root) {
                    var xhr = new XMLHttpRequest();
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) {
                                data = xhr.responseText.split("\n");
                                obj = processData(data);
                                createRedirect();
                            }
                            else if (xhr.status === 404) {
                                console.log('CGI Trace - Service not available');
                            }
                        }
                    };
                    xhr.open('GET', window.location.protocol + '//' + window.location.hostname + '/cdn-cgi/trace', true);
                    xhr.send(null);
                }

                //Smooth Scrolling
                // Select all links with hashes
                $('nav a[href*="#"]')
                // Remove links that don't actually link to anything
                    .not('[href="#"]')
                    .not('[href="#0"]')
                    .click(function (event) {
                        // On-page links
                        if (
                            location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
                            location.hostname === this.hostname
                        ) {
                            // Figure out element to scroll to
                            var target = $(this.hash);
                            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                            // Does a scroll target exist?
                            if (target.length) {
                                // Only prevent default if animation is actually gonna happen
                                event.preventDefault();
                                $('html, body').animate({
                                    scrollTop: target.offset().top - 50
                                }, 1000, function () {
                                    // Callback after animation
                                    // Must change focus!
                                    var $target = $(target);
                                    $target.focus();
                                    if ($target.is(":focus")) { // Checking if the target was focused
                                        return false;
                                    } else {
                                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                                        $target.focus(); // Set focus again
                                    }
                                });
                            }
                        }
                    });

                $("header").headroom({
                    "offset": 105,
                    "tolerance": 5,
                    "classes": {
                        initial: "headroom",
                        // when scrolling up
                        pinned: "headroom--pinned",
                        // when scrolling down
                        unpinned: "headroom--unpinned",
                        // when above offset
                        top: "headroom--top",
                        // when below offset
                        notTop: "headroom--not-top",
                    }
                });

                $(document).ready(function () {
                    $($('.hamburger').parent().attr('data-target')).on('hide.bs.collapse', function () {
                        $(this).parent().find('.hamburger').removeClass('hamburger--close');
                    });
                    $($('.hamburger').parent().attr('data-target')).on('show.bs.collapse', function () {
                        $(this).parent().find('.hamburger').addClass('hamburger--close');
                    });
                });
                /* jshint ignore:start */
                $(document).ready(function ($) {
                    // browser window scroll (in pixels) after which the "back to top" link is shown
                    var offset = 300,
                        //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
                        offset_opacity = 1200,
                        //duration of the top scrolling animation (in ms)
                        scroll_top_duration = 700,
                        //grab the "back to top" link
                        $back_to_top = $('.cd-top');

                    //hide or show the "back to top" link
                    $(window).scroll(function () {
                        ($(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
                        if ($(this).scrollTop() > offset_opacity) {
                            $back_to_top.addClass('cd-fade-out');
                        }
                    });

                    //smooth scroll to top
                    $back_to_top.on('click', function (event) {
                        event.preventDefault();
                        $('body,html').animate({
                                scrollTop: 0,
                            }, scroll_top_duration
                        );
                    });

                });
                /* jshint ignore:end */
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                var tlLogo = new TimelineMax({delay: 0.8});
                tlLogo.from('.logo', 2, {scale: 0, opacity: 0, ease: Elastic.easeOut.config(1, 0.5)})
                    .staggerFrom('.hero h1, .hero h3', 2, {
                        y: '+=30px',
                        opacity: 0,
                        ease: Elastic.easeOut.config(1, 0.6)
                    }, 0.3, '-=1.5');

                var texts = $('.analysis-texts div');
                var needle = $('.needle');

                var tlAnalysisTexts = new TimelineMax({repeat: -1});
                tlAnalysisTexts.staggerTo(texts, 2, {css: {autoAlpha: 1}, repeat: 1, yoyo: true, repeatDelay: 0.5}, 5)
                ;
                var tlAnlysisNeedle = new TimelineMax({repeat: -1});
                tlAnlysisNeedle.fromTo(needle, 24, {
                    transformOrigin: "90% 19%",
                    rotation: 0,
                    ease: Sine.easeInOut
                }, {transformOrigin: "90% 19%", rotation: 210, ease: Sine.easeInOut})
                    .fromTo(needle, 0.5, {
                        transformOrigin: "90% 19%",
                        rotation: 210,
                        ease: Sine.easeInOut
                    }, {transformOrigin: "90% 19%", rotation: 0, ease: Sine.easeInOut})
                ;

            },
            finalize: function () {

            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
